'use client';

import { useIsUserAuthorized } from '@/utils/authHelpers';
import { OrientationSuggestion } from './OrientationSuggestion';

export const OrientationSuggestionWrapper = () => {
  const isUserAuthorized = useIsUserAuthorized();

  if (!isUserAuthorized) {
    return null;
  }

  return <OrientationSuggestion />;
};